import store from '../../../store'
import regionService from '@/http/services/region'
export default {
  fetchRegions ({ commit }, name) {
    return regionService.getRegions(store.state.apiUrl, name).then((regions) => {
      return regions
    })
  },
  fetchCenter ({ commit }) {
    return regionService.fetchCenter(store.state.apiUrl).then((center) => {
      commit('setCenter', center)
      return center
    })
  }
}
